import defaultState from 'shared/product_tabs/tab_accessories/data/defaultState';

const state = {
  ...defaultState,
};

if (Spree.accessories) {
  Spree.accessories.forEach((accessory) => {

    // Added this to avoid duplicate entries of the same line item
    if (accessory.line_item_id) {
      state.accessoriesToDestroy.push(accessory.line_item_id);
    }

    const foundIndex = state.accessoriesInfoList.findIndex((ai) => ai.id === accessory.product_id);
    const accInfo = state.accessoriesInfoList[foundIndex];

    accInfo.quantity = accessory.quantity;
    const selectedVariant = accInfo.variants.length > 0 ?
      accInfo.variants.find((v) => v.id === accessory.variant_id) :
      accInfo.master;
    accInfo.selected_variant = _.cloneDeep(selectedVariant);
    state.accessories.push(accessory);
    accInfo.selected = true;
  });
}

export default state;
